import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-sessionize",
  "use": "icon-op-sessionize-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-sessionize\"><path d=\"M13 3v4.6l-5.7 5.7c-.2.2-.6.4-.9.4s-.6-.1-.9-.4l-2.8-2.8c-.5-.5-.5-1.3 0-1.8L8.4 3zm1-1H8L2 8c-.9.9-.9 2.3 0 3.2L4.8 14c.4.4 1 .6 1.6.6.6.1 1.2-.2 1.6-.6l6-6z\" /><path d=\"M10 5.5c.1 0 .3.1.4.1.2.2.2.5 0 .7-.1.1-.2.1-.4.1-.1 0-.3-.1-.4-.1-.2-.2-.2-.5 0-.7.1-.1.3-.1.4-.1m0-1c-.4 0-.8.1-1.1.4-.6.6-.6 1.5 0 2.1.3.3.7.5 1.1.5s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1-.3-.4-.7-.5-1.1-.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol